/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EMAIL COLLECTION : STYLES --------------- ++++++++++ */
export default theme => ({
    emailcollection: {
        width: '100%',
        padding: pxToEm(16),
        '& .addonheader': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: pxToEm(20),
            '& .link': {
                fontSize: pxToEm(14),
                fontWeight: 500,
                textDecoration: 'none !important'
            },
            '& .button': {
                height: pxToEm(32),
                width: pxToEm(88),
                fontSize: pxToEm(14),
                fontWeight: 500
            },
            '& h4': {
                fontSize: pxToEm(16),
                fontWeight: 'bold'
            }
        },
        '& .emailcollectioncreation': {
            display: 'flex',
            justifyContent: 'center',
            '& .propertycard': {
                opacity: '0',
                animationName: 'fadeInRight',
                animationDelay: '.2s',
                animationDuration: '.1s',
                animationFillMode: 'forwards',
                marginRight: pxToEm(8)
            },
            '& .name-emailcollectioncontainer': {
                opacity: '0',
                animationName: 'fadeInLeft',
                animationDelay: '.2s',
                animationDuration: '.1s',
                animationFillMode: 'forwards',
                width: '100%',
                height: 'fit-content'
            },
            '&.in-content': {
                '& .name-emailcollectioncontainer': {
                    maxWidth: pxToEm(600)
                }
            },
            '&.rail': {
                '& .name-emailcollectioncontainer': {
                    maxWidth: pxToEm(300)
                }
            }
        },
        '& .emailcollectionfooter': {
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: pxToEm(14),
            '& button': {
                height: pxToEm(32),
                width: pxToEm(88)
            },
            '& .queueposition': {
                marginRight: pxToEm(170),
                display: 'flex',
                alignItems: 'center',
                '& label': {
                    fontWeight: 'bold',
                    marginRight: pxToEm(10)
                },
                '& .singleselectdropdown': {
                    width: pxToEm(75),
                    height: pxToEm(32),
                    marginRight: pxToEm(10),
                    '& .placeholder': {
                        padding: pxToEm(10),
                        '& .name-sort-down': {
                            marginRight: 0
                        },
                        '& .itemText': {
                            fontWeight: 'bold'
                        }
                    },
                    '& .name-menuItems': {
                        height: pxToEm(90)
                    }
                }
            }
        }
    }
});
